module.exports = __webpack_public_path__ + "src/img/smaller_viewer.ad2a8961.svg";